export default {
  SET_BREAKING_NEWS: 'SET_BREAKING_NEWS',
};
